import { render } from "./LectureItem.vue?vue&type=template&id=06a8255e&scoped=true"
import script from "./LectureItem.vue?vue&type=script&lang=js"
export * from "./LectureItem.vue?vue&type=script&lang=js"

import "./LectureItem.vue?vue&type=style&index=0&id=06a8255e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06a8255e"]])

export default __exports__